module.exports = __webpack_public_path__ + "static/media/logo.2dbfa212.png";